import SectionHeading from '@/components/feature/SectionHeading';
import { rankings } from '@/mocks/rankings';

const trendMap: Record<string, { icon: string; className: string; label: string }> = {
  up: { icon: 'ri-arrow-up-line', className: 'text-primary-600', label: '热度上升' },
  down: { icon: 'ri-arrow-down-line', className: 'text-foreground-500', label: '热度下降' },
  same: { icon: 'ri-subtract-line', className: 'text-secondary-600', label: '热度持平' },
};

export default function RankingSection() {
  return (
    <section id="ranking" className="w-full bg-background-100 py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 md:gap-8">
          <div className="lg:col-span-1">
            <SectionHeading
              eyebrow="热度排行榜"
              title="综合评分与追更热度"
              desc="榜单综合了评分、追更人数与讨论热度，仅作为挑选参考，不代表唯一标准。想先看口碑作品时，可以从排名靠前的条目入手。"
            />
            <div className="rounded-lg bg-accent-500 p-5 md:p-6 text-foreground-950">
              <span className="w-12 h-12 flex items-center justify-center rounded-lg bg-foreground-950/10 text-2xl">
                <i className="ri-trophy-line"></i>
              </span>
              <h3 className="mt-4 font-heading text-xl">本季榜首</h3>
              <p className="mt-2 text-sm leading-relaxed">
                《星屑彼端的旅人》以 9.1 的评分领跑，公路冒险的叙事节奏与画面表现是本季讨论度最高的部分。
              </p>
            </div>
          </div>

          <div className="lg:col-span-2 rounded-lg border border-background-200 bg-background-50 overflow-hidden">
            <ul className="divide-y divide-background-200">
              {rankings.map((item) => {
                const trend = trendMap[item.trend];
                return (
                  <li key={item.title} className="flex items-center gap-4 px-4 md:px-5 py-4">
                    <span
                      className={`w-9 h-9 md:w-10 md:h-10 shrink-0 flex items-center justify-center rounded-lg font-heading text-base md:text-lg ${
                        item.rank <= 3 ? 'bg-primary-500 text-background-50 dark:text-foreground-950' : 'bg-background-200 text-foreground-700'
                      }`}
                    >
                      {item.rank}
                    </span>
                    <div className="min-w-0 flex-1">
                      <p className="text-sm md:text-base font-medium text-foreground-900 truncate">{item.title}</p>
                      <p className="mt-0.5 text-xs md:text-sm text-foreground-500 truncate">{item.genre}</p>
                    </div>
                    <span className="hidden sm:inline-flex items-center gap-1 text-xs md:text-sm text-foreground-500">
                      <i className={trend.icon}></i>
                      {trend.label}
                    </span>
                    <span className="w-12 shrink-0 text-right font-heading text-base md:text-lg text-accent-700">
                      {item.score.toFixed(1)}
                    </span>
                  </li>
                );
              })}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}